<template>

<el-container>

  <el-header>
    <navbar/>
  </el-header>

  <el-container>

    <sidebar/>

    <el-main class="col-10 offset-2">
      <child/>
    </el-main>

  </el-container>


  <Footer/>


</el-container>

</template>

<script>
import Navbar from '~/components/Navbar'
import Sidebar from '~/components/Sidebar'
import Footer from '~/components/Footer'

export default {
  name: 'MainLayout',

  components: {
    Navbar,
    Sidebar,
    Footer
  }
}
</script>
<style scoped>
  .el-container {
    height: 100%;
  }
  .el-header {
    padding: 0 !important;
    z-index:11;
  }  
</style>



// WEBPACK FOOTER //
// resources/assets/js/layouts/default.vue